module.exports = __webpack_public_path__ + "static/media/member_history_01.dad4c46f.jpg";